//@ts-nocheck
import { useEffect, useRef } from "react";
import { fieldType } from "../../../../types/form";
import { RichTextarea, createRegexRenderer } from "rich-textarea";
import { TooltipItem } from "src/utils/Tooltip";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";

type Props = {
  dataField: fieldType;
  onChange: (data: any) => void;
  errors?: any;
  value: string;
  maxLength?: number;
};

const renderer = createRegexRenderer([[/(^|\W)(#[а-я\w][а-я\w-]*)/gi, { color: "rgb(0,98,155)" }]]);

const MIN_TEXTAREA_HEIGHT = 32;

function TextArea(props: Props) {
  const { dataField, onChange, errors, value, maxLength } = props;
  const editor = useRef();

  useEffect(() => {
    if (dataField.hasOwnProperty('default') && dataField.default) {
      onChange(dataField.default);
    }
  }, [dataField]);

  useEffect(() => {
    // Reset height - important to shrink on delete
    editor.current.style.height = "inherit";
    // Set height
    editor.current.style.height = `${Math.max(editor.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`;
  }, [value]);

  return (
    <div className={`${dataField.width} mb-5 text-black`}>
      <label className="flex flex-row items-center justify-between text-sm font-medium leading-6 text-gray-900">
        <span className="flex flex-row items-center">{dataField.title} {dataField.noticeIcon && <TooltipItem wrapperClassName="flex w-fit sm:w-[758px]" position="top-right" tooltipsComponent={dataField.notice} tooltipsText="">
          <>&nbsp;&nbsp;<InfoIcon /></>
        </TooltipItem>}</span>
        {dataField.require && (
          <div className="flex flex-row justify-between">
            {Object.keys(errors).length > 0 && errors[dataField.key] &&
              <>
                {errors[dataField.key]['type'] === "required" &&
                  <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                }
                {errors[dataField.key]['type'] === "maxLength" &&
                  <span className="text-[#BA0C2F]">Превышено максимальное количество символов: {value.length}/{maxLength}&nbsp;</span>
                }
                {errors[dataField.key]['type'] === "validate" &&
                  <span className="text-[#BA0C2F]">Поле не может состоять только из хештега (пробелы игнорируются)&nbsp;</span>
                }
              </>
            }
            <span className="text-[#BA0C2F]">*</span>
          </div>
        )}
      </label>
      <div className="mt-2 rich-text-area">
        <RichTextarea
          className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom placeholder:text-gray-400 bg-white disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]`}
          style={{
            minHeight: MIN_TEXTAREA_HEIGHT,
            resize: "none",
            width: "100%",
            overflow: "hidden"
          }}
          ref={editor}
          disabled={dataField.disabled}
          value={dataField.default || value}
          placeholder={dataField.placeholder}
          onChange={e => onChange(e.target.value)}
        >
          {renderer}
        </RichTextarea>
      </div>
    </div>
  );
}

export default TextArea;
